// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DZB90Bg8m8s9YvpC {
	color: var(--lok-color-text-light-default);
	border-color: var(--lok-color-border-light);
	font: var(--lok-typography-body-caption-default);
}

/* HACK: Adjust padding of th/td elements to avoid scroll-bar obscuring contents */
.f8dAViU7yEm16MaL {
	padding-inline-start: var(--lok-spacing-3);
}

.Mp_KbEl0wrs6LWgs {
	padding-inline-end: var(--lok-spacing-3);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/KeysForLanguage/components/TmTargetLanguagesView/TmTargetLanguagesView.module.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;CAC1C,2CAA2C;CAC3C,gDAAgD;AACjD;;AAEA,kFAAkF;AAClF;CACC,0CAA0C;AAC3C;;AAEA;CACC,wCAAwC;AACzC","sourcesContent":[".cell {\n\tcolor: var(--lok-color-text-light-default);\n\tborder-color: var(--lok-color-border-light);\n\tfont: var(--lok-typography-body-caption-default);\n}\n\n/* HACK: Adjust padding of th/td elements to avoid scroll-bar obscuring contents */\n.cellLeft {\n\tpadding-inline-start: var(--lok-spacing-3);\n}\n\n.cellRight {\n\tpadding-inline-end: var(--lok-spacing-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `DZB90Bg8m8s9YvpC`,
	"cellLeft": `f8dAViU7yEm16MaL`,
	"cellRight": `Mp_KbEl0wrs6LWgs`
};
export default ___CSS_LOADER_EXPORT___;
